import { Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

export const routes: Routes = [
	{ path: '', loadComponent: () => import('./pages/default-page/default-page.component').then(m => m.DefaultPageComponent), pathMatch: 'full', canActivate: [autoLoginPartialRoutesGuard] },
	{ path: 'stories', loadComponent: () => import('./pages/default-page/default-page.component').then(m => m.DefaultPageComponent), canActivate: [autoLoginPartialRoutesGuard] },
	{ path: 'stories/:storyIdentityCode', loadComponent: () => import('./pages/default-page/default-page.component').then(m => m.DefaultPageComponent), canActivate: [autoLoginPartialRoutesGuard] },
	{ path: 'notfound', loadComponent: () => import('./pages/notfound-page/notfound-page.component').then(m => m.NotFoundPageComponent) },
];
